module.exports = __webpack_public_path__ + "static/media/grin-alt.7f16757e.svg";